import React from 'react';
import { FormattedMessage } from 'react-intl';
import style from './moreLessText.module.scss';
import TruncateLines from 'acscp/components/common/truncateLines';
import classNames from 'classnames';

interface MoreLessTextProps {
    text?: string;
    unsafeHTML?: string;
    minimumLines?: number;
}

interface MoreLessTextState {
    expanded: boolean;
    truncated: boolean;
}

const FormattedMessageForMore = () =>
    (
        <FormattedMessage
            id={'components.common.morelesstext.more'}
            defaultMessage={'More'}
        />
    );

const FormattedMessageForLess = () =>
    (
        <FormattedMessage
            id={'components.common.morelesstext.less'}
            defaultMessage={'Less'}
        />
    );

export {FormattedMessageForMore, FormattedMessageForLess};

export class MoreLessText extends React.Component<MoreLessTextProps, MoreLessTextState> {
    constructor(props: MoreLessTextProps) {
        super(props);
        this.state = { expanded: false, truncated: false };
    }

    private toggleTruncation = (event: any) => {
        event.preventDefault();
        this.setState({ expanded: !this.state.expanded });
    }

    private handleTruncate = (truncateState: {clamped: boolean}) => {
        // Don't update the state if the update wouldn't actually change anything
        // Prevents infinite loop re-renders
        this.setState(prevState => prevState.truncated === truncateState.clamped
            ? null
            : { truncated: truncateState.clamped }
        );
    }

    render(): JSX.Element {
        const minimumLines: number = this.props.minimumLines || 1;
        return (
            <div className={classNames(style.Text, {[style.HTML]: !!this.props.unsafeHTML})}>
                <TruncateLines
                    text={this.props.text}
                    unsafeHTML={this.props.unsafeHTML}
                    lines={this.state.expanded ? 1000000 : minimumLines}
                    onTruncate={this.handleTruncate}
                />
                {this.state.truncated && !this.state.expanded && (
                    <span>
                        <a className={style.More} href="javascript:;" onClick={this.toggleTruncation}>
                            <FormattedMessageForMore/>
                            <div className={style.Triangle}/>
                        </a>
                    </span>
                )}
                {!this.state.truncated && this.state.expanded && (
                    <span>
                        <a className={style.Less} href="javascript:;" onClick={this.toggleTruncation}>
                            <FormattedMessageForLess/>
                            <div className={style.InvertedTriangle}/>
                        </a>
                    </span>
                )}
            </div>
        );
    }
}
